import React from 'react';

import './Logo.css';

interface Props {
  additionalClasses?: string;
  imageUrl: string;
}

const Logo: React.FC<Props> = props => {
  const { additionalClasses, imageUrl } = props;

  if (!imageUrl) {
    return null;
  }

  return (
    <div className={`ui-widget-logo-wrapper ${additionalClasses}`}>
      <img src={imageUrl} alt="logo" className="ui-widget-logo" />
    </div>
  );
};

export default Logo;
